import React, { useState, useRef, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import {
  Container,
  Grid,
  CssBaseline,
  Typography,
  Paper,
  Box,
  Alert,
  Snackbar,
} from "@mui/material";
import RegionInfo from "../components/RegionInfo";
import FilterContent from "../components/FilterContent";
import DATSImpactDashboard from "../components/DatsTab";
import {
  MapContainer,
  TileLayer,
  LayersControl,
  GeoJSON,
  WMSTileLayer,
} from "react-leaflet";
import L from "leaflet";
import { CRS } from "leaflet";
import { useSelector } from "react-redux";
import regionsData from "../data/regions.json";
import { REACT_APP_MAP_SERVER_URL as MAP_SERVER_URL } from "../utils/env";

const MAP_SERVER_ENDPOINT = `${MAP_SERVER_URL.replace(/\/$/, "")}/cgi-bin/mapserv`;

// ─── Constants ────────────────────────────────────────────────────────────────

const VALID_TIF_FILES = [
  "TC1_ROI.tif",
  "TC1_ROI_2023.tif",
  "TC1_ROI_2024.tif",
  "TC1_ROI_2025.tif",
  "TC7_ROI_2024.tif",
  "TC7_ROI_2025.tif",
  "TC7_ROI_A_2024.tif",
  "TC7_ROI_A_2025.tif",
  "TC7_ROI_B_2024.tif",
  "TC7_ROI_B_2025.tif",
  "TC10_ROI_A_2024.tif",
  "TC10_ROI_A_2025.tif",
  "TC10_ROI_B_2024.tif",
  "TC10_ROI_B_2025.tif",
  "TC10_ROI_C_2024.tif",
  "TC10_ROI_C_2025.tif",
  "TC10_ROI_D_2024.tif",
  "TC10_ROI_D_2025.tif",
  "TC10_ROI_E_2024.tif",
  "TC10_ROI_E_2025.tif",
  "TC11_ROI_A_2024.tif",
  "TC11_ROI_A_2025.tif",
  "TC11_ROI_B_2024.tif",
  "TC11_ROI_B_2025.tif",
  "TC11_ROI_C_2024.tif",
  "TC11_ROI_C_2025.tif",
  "TC12_ROI_2024.tif",
  "TC12_ROI_2025.tif",
  "TC13_ROI_2024.tif",
  "TC13_ROI_2025.tif",
  "TC13_ROI_E_2024.tif",
  "TC13_ROI_E_2025.tif",
  "TC13_ROI_D_2024.tif",
  "TC13_ROI_D_2025.tif",
  "TC15_ROI_A_2024.tif",
  "TC15_ROI_A_2025.tif",
  "TC15_ROI_B_2024.tif",
  "TC15_ROI_B_2025.tif",
  "TC15_ROI_C_2024.tif",
  "TC15_ROI_C_2025.tif",
  "TC15_ROI_D_2024.tif",
  "TC15_ROI_D_2025.tif",
  "TC15_ROI_E_2024.tif",
  "TC15_ROI_E_2025.tif",
  "TC15_ROI_F_2024.tif",
  "TC15_ROI_F_2025.tif",
  "TC15_ROI_G_2024.tif",
  "TC16_ROI_2024.tif",
  "TC16_ROI_2025.tif",
  "TC18_ROI_A_2024.tif",
  "TC18_ROI_B_2024.tif",
  "TC18_ROI_C_2024.tif",
  "TC18_ROI_D_2024.tif",
  "TC18_ROI_E_2024.tif",
  "TC18_ROI_F_2024.tif",
  "TC18_ROI_H_2024.tif",
  "TC20_ROI_2023.tif",
  "TC20_ROI_2024.tif",
  "TC20_ROI_2025.tif",
  "TC3_ROI_A_2023.tif",
  "TC3_ROI_A_2024.tif",
  "TC3_ROI_A_2025.tif",
  "TC3_ROI_B_2023.tif",
  "TC3_ROI_B_2024.tif",
  "TC3_ROI_B_2025.tif",
  "TC3_ROI_C_2023.tif",
  "TC3_ROI_C_2024.tif",
  "TC3_ROI_C_2025.tif",
  "TC3_ROI_D_2023.tif",
  "TC3_ROI_D_2024.tif",
  "TC3_ROI_D_2025.tif",
  "TC3_ROI_E_2023.tif",
  "TC3_ROI_E_2024.tif",
  "TC3_ROI_E_2025.tif",
  "TC3_ROI_F_2023.tif",
  "TC3_ROI_F_2024.tif",
  "TC3_ROI_F_2025.tif",
  "TC3_ROI_G_2024.tif",
  "TC3_ROI_G_2025.tif",
  "TC3_ROI_H_2023.tif",
  "TC3_ROI_H_2024.tif",
  "TC3_ROI_H_2025.tif",
  "TC3_ROI_I_2024.tif",
  "TC4_ROI_A_2024.tif",
  "TC4_ROI_A_2025.tif",
  "TC4_ROI_B_2023.tif",
  "TC4_ROI_B_2024.tif",
  "TC4_ROI_B_2025.tif",
  "TC4_ROI_C_2024.tif",
  "TC4_ROI_C_2025.tif",
  "TC9_ROI_A_2024.tif",
  "TC9_ROI_A_2025.tif",
  "TC9_ROI_B_2024.tif",
  "TC9_ROI_B_2025.tif",
  "TC9_ROI_C_2024.tif",
  "TC9_ROI_C_2025.tif",
  "TC9_ROI_D_2024.tif",
  "TC9_ROI_D_2025.tif",
  "TC9_ROI_E_2024.tif",
  "TC9_ROI_E_2025.tif",
  "TC9_ROI_F_2024.tif",
  "TC9_ROI_F_2025.tif",
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

/**
 * Derive the WMS layer type from the TIF filename.
 * Matches _2023, _2024, _2025 suffixes; defaults to _2024.
 */
const getLayerType = (tifName) => {
  if (tifName.includes("_2023")) return "tiff_layer_2023";
  if (tifName.includes("_2025")) return "tiff_layer_2025";
  return "tiff_layer_2024";
};

/**
 * Build a WMS GetCapabilities URL using MAP_SERVER_URL.
 * Safe for production — no localhost references.
 */
const normalizeTifName = (name) => {
  const trimmedName = String(name).trim();
  return trimmedName.endsWith(".tif") ? trimmedName : `${trimmedName}.tif`;
};

const getTifBaseName = (name) =>
  normalizeTifName(name).replace(/_(?:2023|2024|2025)\.tif$/, "");

const getAvailableTifLayers = (layers = []) => {
  const requestedBaseNames = new Set(layers.map(getTifBaseName));
  return VALID_TIF_FILES.filter((fileName) =>
    requestedBaseNames.has(getTifBaseName(fileName))
  );
};

// ─── Sub-components ───────────────────────────────────────────────────────────

const TifLayer = ({ layerName }) => {
  if (!layerName) return null;

  const fullTifName = normalizeTifName(layerName);

  if (!VALID_TIF_FILES.includes(fullTifName)) {
    console.error("Invalid TIF file requested:", fullTifName);
    return null;
  }

  const params = {
    map: "/data/mapfile.map",
    layers: getLayerType(fullTifName),
    format: "image/png",
    transparent: true,
    version: "1.3.0",
    TIFF_NAME: fullTifName,
    styles: "",
  };

  return (
    <WMSTileLayer
      key={`${fullTifName}-${params.layers}`}
      url={MAP_SERVER_ENDPOINT}
      params={params}
      opacity={0.8}
    />
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────

const HomePage = () => {
  const [geoJson] = useState([regionsData]);
  const [activeTifLayers, setActiveTifLayers] = useState([]);
  const [mapServerError, setMapServerError] = useState(false);
  const dataFilter = useSelector((state) => state.cropStats.data);
  const mapRef = useRef(null);

  // ── Zoom to a GeoJSON feature and optionally load its TIF layers ────────────
  const zoomToFeature = (feature, loadLayers = false) => {
    if (!mapRef.current || !feature?.geometry?.coordinates?.length) return;

    try {
      const geojsonLayer = L.geoJSON(feature);
      const bounds = geojsonLayer.getBounds();
      if (!bounds.isValid()) return;

      const { LAU_NAME, Country, AREA_HA } = feature.properties;

      mapRef.current.flyToBounds(bounds, {
        padding: [50, 50],
        maxZoom: 12,
        duration: 1,
        animate: true,
      });

      L.popup()
        .setLatLng(bounds.getCenter())
        .setContent(
          `<b>Region Name:</b> ${LAU_NAME}<br>
           <b>Country:</b> ${Country}<br>
           <b>Area (ha):</b> ${AREA_HA?.toFixed(1)}`
        )
        .openOn(mapRef.current);

      if (loadLayers && feature.properties?.layers?.length) {
        setActiveTifLayers(getAvailableTifLayers(feature.properties.layers));
      }
    } catch (err) {
      console.error("Error zooming to feature:", err);
    }
  };

  // ── Sync map when filter selection changes ──────────────────────────────────
  useEffect(() => {
    if (!dataFilter?.Country || !dataFilter?.LAU_NAME) {
      setActiveTifLayers([]);
      return;
    }

    const feature = geoJson[0]?.features?.find(
      (f) =>
        f.properties?.Country === dataFilter.Country &&
        f.properties?.LAU_NAME === dataFilter.LAU_NAME
    );

    if (feature && mapRef.current) {
      requestAnimationFrame(() => zoomToFeature(feature, true));
    }
  }, [dataFilter, geoJson]);

  // ── GeoJSON popup + click handler ───────────────────────────────────────────
  const onEachFeature = (feature, layer) => {
    const { LAU_NAME, Country, AREA_HA } = feature.properties;

    layer.bindPopup(
      `<b>Region Name:</b> ${LAU_NAME}<br>
       <b>Country:</b> ${Country}<br>
       <b>Area (ha):</b> ${AREA_HA?.toFixed(1)}`
    );

    layer.on("click", () => {
      setMapServerError(false);
      // Only zoom — TIF layers are controlled by the filter selection, not map clicks
      zoomToFeature(feature, false);
    });
  };

  return (
    <Grid container>
      <CssBaseline />

      <Snackbar
        open={mapServerError}
        autoHideDuration={6000}
        onClose={() => setMapServerError(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setMapServerError(false)}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          MapServer is not responding
        </Alert>
      </Snackbar>

      {/* ── Left column: filter + info + dashboard ── */}
      <Grid item xs={7}>
        <Container maxWidth="xl" sx={{ mt: "1%" }}>
          <Grid item xs={12} sx={{ m: 1, top: 65, zIndex: 100 }}>
            <FilterContent title="Filter Content" />
          </Grid>
          <Grid item xs={12} sx={{ m: 1 }}>
            <RegionInfo
              title="Regional Information"
              data={dataFilter}
              layers={activeTifLayers}
            />
          </Grid>
          <Grid>
            <DATSImpactDashboard
              test_case_id={dataFilter.TC_number}
              selectedCrop={dataFilter.cropType}
              selectedCountry={dataFilter.Country}
              selectedRegion={dataFilter.LAU_NAME}
              cropArea={dataFilter.CropArea}
            />
          </Grid>
        </Container>
      </Grid>

      {/* ── Right column: map ── */}
      <Grid item xs={5}>
        <Container
          sx={{
            top: 0,
            bottom: 0,
            height: "100vh",
            width: "41.5%",
            display: "flex",
            position: "fixed",
            padding: "0 0 12px 0",
          }}
        >
          <MapContainer
            center={[48.7, 17.3]}
            zoom={4}
            scrollWheelZoom={true}
            style={{ width: "100%", height: "100%", position: "relative" }}
            ref={mapRef}
            crs={CRS.EPSG3857}
          >
            <LayersControl position="topright">
              <LayersControl.BaseLayer checked name="Google Map">
                <TileLayer
                  url="https://{s}.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright" target=_blank>Google Maps</a>'
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="Open Street Map">
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright" target=_blank>Open Street Map</a>'
                />
              </LayersControl.BaseLayer>

              <LayersControl.BaseLayer name="ESRI:World Shaded Relief">
                <TileLayer
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}"
                  attribution='&copy; <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Shaded_Relief/MapServer" target=_blank>World Shaded Relief</a>'
                  subdomains="abcd"
                />
              </LayersControl.BaseLayer>

              {geoJson.length > 0 && (
                <GeoJSON
                  data={geoJson}
                  onEachFeature={onEachFeature}
                  style={() => ({
                    color: "#0000CD",
                    weight: 2,
                    fillOpacity: 0,
                    opacity: 1,
                  })}
                />
              )}

              {activeTifLayers.map((layerName, index) => (
                <LayersControl.Overlay
                  key={`${layerName}-${index}`}
                  checked
                  name={layerName.replace(".tif", "")}
                >
                  <TifLayer layerName={layerName} />
                </LayersControl.Overlay>
              ))}
            </LayersControl>
          </MapContainer>

          {/* No GeoJSON fallback */}
          {geoJson.length === 0 && (
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1000,
              }}
            >
              <Paper elevation={4} sx={{ p: 2 }}>
                <Typography>No GeoJson data available.</Typography>
                <Typography>Reload the page or add a valid GeoJson.</Typography>
              </Paper>
            </Box>
          )}
        </Container>
      </Grid>
    </Grid>
  );
};

export default HomePage;
